import React from 'react';

import { noop } from 'lodash';

import UserAvatarButton from './UserAvatarButton';

import { IAuthUser } from '~/context/AuthContext';
import DropdownMenu, { DropdownMenuGroup } from '~/core/atoms/DropdownMenu';
import ActionArrowIcon from '~/core/iconComponents/icons/ActionArrowIcon';

interface UserMenuProps {
  user: IAuthUser | null;
  onLogout?: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({ user, onLogout = noop }) => {
  const menuGroups: DropdownMenuGroup[] = [
    {
      items: [
        {
          label: user ? (
            <div className="mx-20 my-16 flex flex-col items-start gap-12">
              <div className="text-base">{user?.account}</div>
              <div className="flex items-center gap-12">
                <UserAvatarButton user={user} />
                <div className="flex flex-col">
                  <span className="flex-1 text-lg font-medium">{user?.name}</span>
                  <span className="flex-1 text-sm">{user?.email}</span>
                </div>
              </div>
            </div>
          ) : null,
          disabled: false,
        },
      ],
    },
    {
      items: [
        {
          label: 'Logout',
          onClick: onLogout,
          icon: <ActionArrowIcon className="text-black" size={18} direction="right" />,
          className: 'flex items-center justify-center py-12 text-sm font-medium',
        },
      ],
    },
  ];

  return <DropdownMenu groups={menuGroups} customMenuButton={<UserAvatarButton user={user} />} />;
};

export default UserMenu;
